import { useTranslation } from 'react-i18next'

import { useContentOverflow } from '../../../../hooks'
import { FloatingTooltip } from '../../../Floating'
import Text from '../../../Text'
import { ExportModalFilesListItem } from '../ExportModalFilesListItem'

import * as styles from './ExportModalFilesList.module.css'

function ExportModalFilesList({
  className = styles.ExportModalFilesList,
  exportLinkTitleKey,
  items,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow()

  const text = t(
    items.length > 1
      ? 'Request.ModalExportFilesListTitlePluralKey'
      : 'Request.ModalExportFilesListTitleKey'
  )

  return (
    <div className={className}>
      <FloatingTooltip content={text} disabled={!overflow}>
        <Text ref={setContentOverflowRef}>{text}</Text>
      </FloatingTooltip>
      {items.map((id, index) => (
        <ExportModalFilesListItem
          exportLinkTitleKey={exportLinkTitleKey}
          id={id}
          index={index}
          key={id}
        />
      ))}
    </div>
  )
}

export default ExportModalFilesList
